<template>
  <div>
    <UserProperty
      @dataAvailable="
        data => {
          userData = data
        }
      "
      isComponent
    />

    <AppDataProperty
      contentId="appInfo"
      @dataAvailable="
        data => {
          appInfo = data?.metaData || {}
        }
      "
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'
import UserProperty from '../user/UserProperty.vue'
import AppDataProperty from './AppDataProperty.vue'

export default defineComponent({
  name: 'VipSubscription',
  components: { ModalComponent, AppDataProperty, UserProperty },
  props: {},
  data() {
    return {
      eventsIds: [],
      userData: {},
      appInfo: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'vip_subscription_requested',
      this.onSubscriptionRequest,
    )
    const id2 = this.$Events.handleEvent(
      'vip_subscription_launched',
      this.onVipSubscriptionLaunched,
    )
    const id3 = this.$Events.handleEvent(
      'failed_to_launch_vip_subscription',
      this.failedToLaunchSubscription,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.eventsIds.push(id3)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async onSubscriptionRequest() {
      let phoneNumber = this.userData.phoneNumber

      phoneNumber = await this.getConfirmedPhoneNumber(phoneNumber)
      if (!phoneNumber) return
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('launch_vip_subscription', {
        phoneNumber,
        src: 'momo',
        dst: 'subscription',
      })
    },
    async getConfirmedPhoneNumber(phoneNumber) {
      const phoneConfirmOptions = [
        {
          usePhone: true,
          title: `${this.$t(
            'subscription.yesPayWith',
          )} ${this.nationalPhoneNumber(phoneNumber)}`,
        },
        { usePhone: false, title: this.$t('subscription.noUseAnotherNumber') },
      ]
      const prompt = await window.choicePrompt({
        title: `${this.$t(
          'subscription.usePhoneNumber',
        )} ${this.nationalPhoneNumber(phoneNumber)} ?`,
        subTitle: `${this.$t('subscription.confirmSubscriptionText', {
          amount: this.appInfo.vipSubscriptionAmount,
        })} ${phoneNumber}. ${this.$t('subscription.proceed')}`,
        options: phoneConfirmOptions,
        formatDisplay: data => data?.title || '',
        successText: this.$t('subscription.continue'),
      })
      if (!prompt.accepted || !prompt.data) return null
      if (prompt.data.usePhone) return this.nationalPhoneNumber(phoneNumber)
      await new Promise(r => setTimeout(r, 500))
      const newPhoneNumber = await this.requestNewPhoneNumber()
      await new Promise(r => setTimeout(r, 500))
      if (!newPhoneNumber) return null
      return this.getConfirmedPhoneNumber(newPhoneNumber)
    },
    async requestNewPhoneNumber() {
      let country = this.$Countries.getPhoneCountry(this.userData?.phoneNumber)
      const prompt = await window.customPrompt({
        title: this.$t('subscription.enterPhoneNumber'),
        subTitle: this.$t('subscription.enterPhoneNumberSubTitle'),
        formFields: [
          {
            type: 'number',
            propertyName: 'phoneNumber',
            label: this.$t('subscription.mobileMoneyNumber'),
            defaultValue: '',
            inputProps: {
              minLenght: 6,
              allowTrailingZero: true,
              prefix: country.phonePrefix,
            },
          },
        ],
        successText: this.$t('subscription.continue'),
      })
      if (!prompt.accepted) return null
      return `${prompt.data.phoneNumber}`
    },
    nationalPhoneNumber(fullPhoneNumber) {
      if (!fullPhoneNumber) return ''
      let country = this.$Countries.getPhoneCountry(this.userData?.phoneNumber)
      if (!fullPhoneNumber.startsWith(country.phonePrefix))
        return fullPhoneNumber
      return fullPhoneNumber.slice(3)
    },
    onVipSubscriptionLaunched() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: this.$t('subscription.paymentStarted'),
        body: this.$t('subscription.paymentStartedBody'),
      })
    },
    failedToLaunchSubscription(data) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        title: this.$t('subscription.launchFailed'),
        body: this.$t('subscription.launchFailedBody'),
      })
    },
  },
  computed: {},
})
</script>
